module.exports = __webpack_public_path__ + "img/file-csv.2ee175b8.svg";